module.exports = __webpack_public_path__ + "static/mushroom-cd763902c68d47690ebcee9c7221b524.svg";